import { render, staticRenderFns } from "./EPDashboardTotalTXNComponent.vue?vue&type=template&id=12c20b8a&"
import script from "./EPDashboardTotalTXNComponent.vue?vue&type=script&lang=js&"
export * from "./EPDashboardTotalTXNComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports